// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function callback_request_response_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var callback_request_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "callback_request_id"), null));
  if (callback_request_id.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              callback_request_id: callback_request_id._0
            }
          };
  }
  var e = callback_request_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".callback_request_id" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var callback_request_response = callback_request_response_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "callback_request_response"), null));
  if (callback_request_response.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              callback_request_response: callback_request_response._0
            }
          };
  }
  var e = callback_request_response._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".callback_request_response" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  callback_request_response_decode ,
  t_decode ,
}
/* No side effect */
